import * as React from 'react';
import { InvoicesContext } from './invoicesContext';
import invoicesReducer from './invoicesReducer';

export default function InvoicesProvider({ children }) {

  const [state, dispatch] = React.useReducer(invoicesReducer, {
    allInvoices: [],
  })

  const value = [state, dispatch];

  return (
    <InvoicesContext.Provider value={ value }>
      { children }
    </InvoicesContext.Provider>
  )
}